export default __webpack_public_path__ + "static/media/infor.6ef81bab.jpg";